import { RouteType } from "../../../types/RouteType";
import { BidsListStore } from "./BidsList.Store";
import { BidFormStore } from "./dialogs/BidForm/BidForm.Store";
import { RootStore } from "stores";

const bidsListRoute: RouteType = {
  name: "Bids",
  path: "/crm/bids",
  layout: "/app",
  hidden: true,
  viewportCard: {
    header: {
      title: "Bids",
      component: () => import("./BidsList.Header"),
    },
    body: {
      grayBackground: true,
      component: () => import("./BidsList.Body"),
    },
  },
  group: "CRM",
  requiresAuth: true,
  requiresPermission: false,
  beforeEnter: async ({ rootStore }) => {
    // Load bids data before entering the route
    const bidsListStore = rootStore.bidsListStore as BidsListStore;
    await bidsListStore.loadBids();
    return true;
  },
  dialogs: [
    {
      name: "Bid Form",
      component: () => import("./dialogs/BidForm/BidForm.Body"),
      title: "Bid Form",
      onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
        const bidFormStore = rootStore.bidFormStore as BidFormStore;

        const result = await bidFormStore.saveBid();
        if (result) {
          // Refresh the bids list after successful submission
          const bidsListStore = rootStore.bidsListStore as BidsListStore;
          await bidsListStore.loadBids();
        }
        return result;
      },
      onSubmitValidation: ({ rootStore }: { rootStore: RootStore }) => {
        const bidFormStore = rootStore.bidFormStore as BidFormStore;
        return !bidFormStore.validateForm();
      },
      height: 720,
    },
    {
      name: "bidDetail",
      component: () => import("./dialogs/BidDetail/BidDetail.Body"),
      title: "Bid Details",
      cancelButton: true,
      height: 800,
    },
  ],
};

export default bidsListRoute;
